// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---- from App.css lines 2513-2947 ---- */
/* ===== Form Pilota - Premium Style ===== */
.pilot-form {
  background: linear-gradient(135deg, rgba(20, 20, 20, 0.5), rgba(10, 10, 10, 0.4));
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.05);
  margin-bottom: 20px;
  text-align: left;
  position: relative;
  overflow: hidden;
}

.pilot-form::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg,
      rgba(192, 255, 3, 0.6),
      rgba(192, 255, 3, 0.3),
      transparent);
  opacity: 0.8;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 12px;
}

.form-col label {
  display: block;
  font-size: .95rem;
  margin-bottom: 6px;
  color: var(--fg);
  font-weight: 600;
}

.input {
  width: 100%;
  background: var(--glass);
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 10px 12px;
  color: var(--fg);
  outline: none;
}

.input:focus {
  border-color: rgba(192, 255, 3, 0.55);
}

.chips {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.chip {
  border: 1px solid var(--line);
  background: var(--glass);
  padding: 6px 10px;
  border-radius: 999px;
  cursor: pointer;
  transition: .2s;
  font-size: .92rem;
  color: white !important;
}

.chip.active {
  background: rgba(192, 255, 3, 0.15);
  border-color: rgba(192, 255, 3, 0.55);
}

.chip.readonly {
  cursor: default;
  color: white;
}

/* Timer Chip */
.chip--timer {
  display: inline-flex;
  align-items: center;
  background: rgba(0, 188, 212, 0.15);
  border-color: rgba(0, 188, 212, 0.4);
  color: #00bcd4;
  font-variant-numeric: tabular-nums;
}

/* Formation Lap Chip */
.chip--formation-lap {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 152, 0, 0.2);
  border-color: rgba(255, 152, 0, 0.5);
  color: #ff9800;
  animation: formation-lap-chip-pulse 2s ease-in-out infinite;
}

@keyframes formation-lap-chip-pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }
}

.form-actions {
  margin-top: 6px;
  display: flex;
  justify-content: flex-end;
}

.btn-primary {
  background: var(--brand);
  color: #0a0a0a;
  border: none;
  padding: 10px 16px;
  border-radius: 10px;
  font-weight: 800;
  cursor: pointer;
}

.btn-primary:disabled {
  opacity: .6;
  cursor: not-allowed;
}

.btn-danger {
  background: transparent;
  color: var(--down);
  border: 1px solid rgba(255, 107, 107, 0.5);
  padding: 8px 12px;
  border-radius: 10px;
  cursor: pointer;
  transition: .2s;
}

.btn-danger:hover {
  background: rgba(255, 107, 107, 0.08);
}

.btn-ghost {
  background: transparent;
  border: 1px solid var(--line);
  color: var(--fg);
  padding: 6px 10px;
  border-radius: 10px;
  cursor: pointer;
}

.btn-ghost:hover {
  background: var(--glass);
}

.muted {
  color: var(--muted);
  font-size: .9rem;
}

.error {
  color: var(--error);
  background: rgba(255, 107, 107, 0.1);
  border: 1px solid rgba(255, 107, 107, 0.3);
  padding: 10px;
  border-radius: 12px;
}

/* Dropzone */
.dz {
  border: 1px dashed var(--line);
  background: var(--glass);
  border-radius: 12px;
  padding: 14px;
  text-align: center;
  min-height: 110px;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: .2s;
}

.dz.over {
  border-color: rgba(192, 255, 3, 0.55);
  background: rgba(192, 255, 3, 0.08);
}

.dz-inner .dz-label {
  display: block;
  font-weight: 700;
  color: white;
}

.dz-inner .dz-hint {
  display: block;
  color: var(--muted);
  font-size: .9rem;
  margin-top: 4px;
}

.dz-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.dz-preview img {
  max-height: 70px;
  max-width: 100%;
  border-radius: 8px;
  object-fit: cover;
}

.dz-filename {
  font-size: .85rem;
  color: var(--muted);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ===== Barra di ricerca piloti ===== */
.pilot-search {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 14px;
  box-shadow: var(--shadow);
  margin: 12px 0 8px;
  text-align: left;
}

.search-input {
  width: 100%;
  margin-bottom: 10px;
}

.search-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
}

/* ===== Griglia piloti / card ===== */
.pilots-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(250px, 1fr));
  gap: 14px;
  margin-bottom: 30px;
}

.pilots-grid-assegnazione {
  display: grid;
  grid-template-columns: repeat(3, minmax(0px, 1fr));
  gap: 14px;
  margin-bottom: 30px;
}

/* nuova card con più spazio alla colonna info */
.pilot-card {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 14px;
  box-shadow: var(--shadow);
  display: grid;
  grid-template-columns: 140px 1fr auto;
  /* più spazio alla colonna centrale */
  gap: 14px;
  align-items: center;
}

.pilot-card.expanded {
  align-items: start;
}

.pilot-photos.col {
  display: grid;
  grid-template-rows: 1fr 90px;
  gap: 10px;
}

.photo {
  background: var(--glass);
  border: 1px solid var(--line);
  border-radius: 10px;
  height: 90px;
  display: grid;
  place-items: center;
  overflow: hidden;
}

.photo.tall {
  height: 180px;
}

.photo.small {
  height: 90px;
}

.photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-placeholder {
  color: var(--muted);
  font-size: .9rem;
}

.pilot-info {
  text-align: left;
}

.pilot-info.wide {
  padding-top: 4px;
}

.pilot-name {
  font-weight: 900;
  letter-spacing: .3px;
  color: white;
}

.pilot-name.big {
  font-size: 1rem;
}

.pilot-team {
  color: var(--muted);
  margin: 4px 0 10px;
}

.pilot-team.big {
  font-size: 1.05rem;
}

.pilot-chips {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.pilot-actions {
  display: flex;
  align-items: center;
}

@media (max-width: 960px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .pilots-grid {
    grid-template-columns: 1fr;
  }

  .pilot-card {
    grid-template-columns: 110px 1fr;
  }

  .pilot-actions {
    grid-column: 1 / -1;
    justify-content: flex-end;
  }
}

.cr-meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  gap: 10px;
  width: 100%;
  margin-top: 6px;
  /* opzionale, se ti serve spacing */
}

.cr-meta .pill {
  display: block;
  text-align: center;
  border-radius: 999px;
  padding: 6px 10px;
  font-size: .9rem;
  background: var(--glass);
  border: 1px solid var(--line);
  color: var(--fg);
}

/* ===== RaceSetup media helpers ===== */
.media-box {
  display: grid;
  place-items: center;
  background: var(--glass);
  border: 1px solid var(--line);
  border-radius: 10px;
  overflow: hidden;
}

/* Foto pilota alta: copre tutto il box senza deformarsi */
.pilot-photo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Logo team nel box piccolo: centrato e contenuto */
.team-logo-box {
  background: var(--glass);
}

.team-logo-img {
  max-height: 70px;
  max-width: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

/* Chip MAC più compatto */
.mac-chip {
  font-size: .8rem;
  opacity: .9;
}

/* ---- from App.css lines 8373-8986 ---- */
/* ===== PREMIUM PILOTS PAGE STYLES ===== */

/* Header Premium */
/* .pilots-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  padding: 24px;
  background: linear-gradient(135deg, rgba(192, 255, 3, 0.08), rgba(192, 255, 3, 0.02));
  border: 1px solid rgba(192, 255, 3, 0.2);
  border-radius: 16px;
  backdrop-filter: blur(10px);
} */

.pilots-header-content {
  flex: 1 1;
}

.section-title-premium {
  font-size: 2.2rem;
  font-weight: 900;
  margin: 0 0 8px 0;
  color: var(--brand);
  letter-spacing: -0.5px;
  text-shadow: 0 0 30px rgba(192, 255, 3, 0.3);
}

.section-subtitle-text {
  color: var(--muted);
  font-size: 1rem;
  margin: 0;
}

.pilots-stats {
  display: flex;
  gap: 20px;
}

.stat-card {
  background: var(--glass);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 16px 24px;
  text-align: center;
  min-width: 120px;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  border-color: rgba(192, 255, 3, 0.3);
}

.stat-value {
  font-size: 2.5rem;
  font-weight: 900;
  color: var(--brand);
  line-height: 1;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 0.85rem;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

/* Form Container Premium */
.pilot-form-container {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  margin-bottom: 32px;
  overflow: hidden;
}

.form-header {
  background: linear-gradient(135deg, rgba(192, 255, 3, 0.12), rgba(192, 255, 3, 0.05));
  padding: 20px 24px;
  border-bottom: 1px solid var(--line);
}

.form-title {
  font-size: 1.4rem;
  font-weight: 800;
  margin: 0;
  color: var(--fg);
  letter-spacing: -0.3px;
}

.form-divider {
  height: 3px;
  background: linear-gradient(90deg, var(--brand), transparent);
  margin-top: 12px;
  border-radius: 2px;
}

.pilot-form-premium {
  padding: 24px;
}

.form-section {
  margin-bottom: 28px;
}

.section-label {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--brand);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid rgba(192, 255, 3, 0.2);
}

.form-col-full {
  grid-column: 1 / -1;
}

.input-premium {
  width: 100%;
  background: var(--glass);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 12px 16px;
  color: var(--fg);
  font-size: 1rem;
  outline: none;
  transition: all 0.3s ease;
}

.input-premium:focus {
  border-color: rgba(192, 255, 3, 0.6);
  box-shadow: 0 0 0 4px rgba(192, 255, 3, 0.1);
  transform: translateY(-1px);
}

.input-premium::placeholder {
  color: var(--muted);
}

.chips-premium {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.chip-premium {
  border: 1px solid var(--line);
  background: var(--glass);
  padding: 10px 18px;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--fg);
  position: relative;
  overflow: hidden;
}

.chip-premium::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(192, 255, 3, 0.15), rgba(192, 255, 3, 0.05));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.chip-premium:hover::before {
  opacity: 1;
}

.chip-premium:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.chip-premium.active {
  background: linear-gradient(135deg, rgba(192, 255, 3, 0.2), rgba(192, 255, 3, 0.1));
  border-color: var(--brand);
  color: var(--brand);
  box-shadow: 0 0 20px rgba(192, 255, 3, 0.3);
}

.btn-primary-premium {
  background: linear-gradient(135deg, var(--brand), #a8ff00);
  color: #0a0a0a;
  border: none;
  padding: 14px 32px;
  border-radius: 12px;
  font-weight: 800;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 16px rgba(192, 255, 3, 0.3);
}

.btn-primary-premium:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(192, 255, 3, 0.4);
}

.btn-primary-premium:active:not(:disabled) {
  transform: translateY(0);
}

.btn-primary-premium:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.btn-icon {
  font-size: 1.2rem;
  line-height: 1;
}

.btn-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #0a0a0a;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Search Premium */
.pilot-search-premium {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  margin-bottom: 32px;
}

.search-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.search-actions {
  display: flex;
  gap: 12px;
}

.btn-clear {
  background: transparent;
  border: 1px solid var(--line);
  color: var(--fg);
  padding: 8px 16px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-clear:hover {
  background: rgba(255, 107, 107, 0.1);
  border-color: rgba(255, 107, 107, 0.5);
  color: var(--down);
}

.search-bar {
  position: relative;
  margin-bottom: 20px;
}

.search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--muted);
  pointer-events: none;
}

.input-search-premium {
  width: 100%;
  background: var(--glass);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 14px 16px 14px 48px;
  color: var(--fg);
  font-size: 1rem;
  outline: none;
  transition: all 0.3s ease;
}

.input-search-premium:focus {
  border-color: rgba(192, 255, 3, 0.6);
  box-shadow: 0 0 0 4px rgba(192, 255, 3, 0.1);
}

.input-search-premium::placeholder {
  color: var(--muted);
}

.filter-chips {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.filter-label {
  font-size: 0.9rem;
  color: var(--muted);
  font-weight: 600;
}

.chip-premium-filter {
  border: 1px solid var(--line);
  background: var(--glass);
  padding: 8px 16px;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--fg);
}

.chip-premium-filter:hover {
  transform: translateY(-1px);
  border-color: rgba(192, 255, 3, 0.4);
}

.chip-premium-filter.active {
  background: linear-gradient(135deg, rgba(192, 255, 3, 0.2), rgba(192, 255, 3, 0.1));
  border-color: var(--brand);
  color: var(--brand);
}

/* Loading State */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 20px;
}

.spinner-large {
  width: 48px;
  height: 48px;
  border: 4px solid var(--line);
  border-top-color: var(--brand);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Error Premium */
.error-premium {
  color: var(--down);
  background: rgba(255, 107, 107, 0.12);
  border: 1px solid rgba(255, 107, 107, 0.4);
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 24px;
  font-weight: 600;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));
  border: 1px dashed var(--line);
  border-radius: 16px;
  margin: 20px 0;
}

.empty-icon {
  font-size: 4rem;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state h3 {
  font-size: 1.4rem;
  font-weight: 800;
  margin: 0 0 12px 0;
  color: var(--fg);
}

/* Pilots Grid Premium */
.pilots-grid-premium {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
  margin-bottom: 40px;
}

/* Pilot Card Premium */
.pilot-card-premium {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));
  border: 1px solid var(--line);
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.4s ease;
  position: relative;
}

.pilot-card-premium::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(192, 255, 3, 0.08), transparent);
  opacity: 0;
  transition: opacity 0.4s ease;
  pointer-events: none;
}

.pilot-card-premium:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
  border-color: rgba(192, 255, 3, 0.4);
}

.pilot-card-premium:hover::before {
  opacity: 1;
}

.pilot-card-header {
  position: relative;
  height: 220px;
  background: linear-gradient(135deg, rgba(192, 255, 3, 0.1), rgba(192, 255, 3, 0.02));
  overflow: hidden;
}

.pilot-avatar {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--glass);
}

.pilot-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.pilot-card-premium:hover .pilot-avatar img {
  transform: scale(1.05);
}

.pilot-team-logo {
  position: absolute;
  bottom: 12px;
  right: 12px;
  width: 56px;
  height: 56px;
  background: rgba(10, 10, 10, 0.9);
  border: 2px solid var(--line);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
}

.pilot-team-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.pilot-card-body {
  padding: 20px;
}

.pilot-name-premium {
  font-size: 1.3rem;
  font-weight: 900;
  margin: 0 0 8px 0;
  color: var(--fg);
  letter-spacing: -0.3px;
  line-height: 1.2;
}

.pilot-team-premium {
  color: var(--muted);
  font-size: 1rem;
  margin: 0 0 16px 0;
  font-weight: 600;
}

.pilot-badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.badge-championship,
.badge-formula {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-championship {
  background: linear-gradient(135deg, rgba(192, 255, 3, 0.2), rgba(192, 255, 3, 0.1));
  color: var(--brand);
  border: 1px solid rgba(192, 255, 3, 0.3);
}

.badge-formula {
  background: rgba(255, 255, 255, 0.08);
  color: var(--fg);
  border: 1px solid var(--line);
}

.pilot-card-footer {
  padding: 16px 20px;
  border-top: 1px solid var(--line);
  background: rgba(0, 0, 0, 0.2);
}

.btn-delete-premium {
  width: 100%;
  background: transparent;
  color: var(--down);
  border: 1px solid rgba(255, 107, 107, 0.4);
  padding: 10px 16px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-delete-premium:hover {
  background: rgba(255, 107, 107, 0.12);
  border-color: rgba(255, 107, 107, 0.6);
  transform: translateY(-1px);
}

.btn-delete-premium svg {
  transition: transform 0.3s ease;
}

.btn-delete-premium:hover svg {
  transform: scale(1.1);
}

/* Responsive */
@media (max-width: 768px) {
  .pilots-header {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .pilots-stats {
    width: 100%;
    justify-content: center;
  }

  .section-title-premium {
    font-size: 1.8rem;
  }

  .pilots-grid-premium {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/legacy/pilots-legacy.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C,4CAA4C;AAC5C;EACE,iFAAiF;EACjF,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,kFAAkF;EAClF,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;kBAGgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;EACd,kCAAkC;AACpC;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;EACd,2DAA2D;AAC7D;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,yFAAyF;EACzF,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,SAAS;EACT,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,yFAAyF;EACzF,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,qCAAqC;EACrC,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,SAAS;EACT,WAAW;EACX,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,2CAA2C;AAC3C,2CAA2C;;AAE3C,mBAAmB;AACnB;;;;;;;;;;GAUG;;AAEH;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,yFAAyF;EACzF,6BAA6B;EAC7B,mBAAmB;EACnB,UAAU;EACV,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qFAAqF;EACrF,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qFAAqF;EACrF,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mFAAmF;EACnF,0BAA0B;EAC1B,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,0DAA0D;EAC1D,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,mBAAmB;AACnB;EACE,yFAAyF;EACzF,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,mFAAmF;EACnF,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yFAAyF;EACzF,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,yFAAyF;EACzF,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yEAAyE;EACzE,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oFAAoF;EACpF,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mFAAmF;EACnF,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ---- from App.css lines 2513-2947 ---- */\n/* ===== Form Pilota - Premium Style ===== */\n.pilot-form {\n  background: linear-gradient(135deg, rgba(20, 20, 20, 0.5), rgba(10, 10, 10, 0.4));\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.05);\n  margin-bottom: 20px;\n  text-align: left;\n  position: relative;\n  overflow: hidden;\n}\n\n.pilot-form::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg,\n      rgba(192, 255, 3, 0.6),\n      rgba(192, 255, 3, 0.3),\n      transparent);\n  opacity: 0.8;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 12px;\n}\n\n.form-col label {\n  display: block;\n  font-size: .95rem;\n  margin-bottom: 6px;\n  color: var(--fg);\n  font-weight: 600;\n}\n\n.input {\n  width: 100%;\n  background: var(--glass);\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  padding: 10px 12px;\n  color: var(--fg);\n  outline: none;\n}\n\n.input:focus {\n  border-color: rgba(192, 255, 3, 0.55);\n}\n\n.chips {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.chip {\n  border: 1px solid var(--line);\n  background: var(--glass);\n  padding: 6px 10px;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: .2s;\n  font-size: .92rem;\n  color: white !important;\n}\n\n.chip.active {\n  background: rgba(192, 255, 3, 0.15);\n  border-color: rgba(192, 255, 3, 0.55);\n}\n\n.chip.readonly {\n  cursor: default;\n  color: white;\n}\n\n/* Timer Chip */\n.chip--timer {\n  display: inline-flex;\n  align-items: center;\n  background: rgba(0, 188, 212, 0.15);\n  border-color: rgba(0, 188, 212, 0.4);\n  color: #00bcd4;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Formation Lap Chip */\n.chip--formation-lap {\n  display: inline-flex;\n  align-items: center;\n  background: rgba(255, 152, 0, 0.2);\n  border-color: rgba(255, 152, 0, 0.5);\n  color: #ff9800;\n  animation: formation-lap-chip-pulse 2s ease-in-out infinite;\n}\n\n@keyframes formation-lap-chip-pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.7;\n  }\n}\n\n.form-actions {\n  margin-top: 6px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.btn-primary {\n  background: var(--brand);\n  color: #0a0a0a;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 10px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.btn-primary:disabled {\n  opacity: .6;\n  cursor: not-allowed;\n}\n\n.btn-danger {\n  background: transparent;\n  color: var(--down);\n  border: 1px solid rgba(255, 107, 107, 0.5);\n  padding: 8px 12px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: .2s;\n}\n\n.btn-danger:hover {\n  background: rgba(255, 107, 107, 0.08);\n}\n\n.btn-ghost {\n  background: transparent;\n  border: 1px solid var(--line);\n  color: var(--fg);\n  padding: 6px 10px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.btn-ghost:hover {\n  background: var(--glass);\n}\n\n.muted {\n  color: var(--muted);\n  font-size: .9rem;\n}\n\n.error {\n  color: var(--error);\n  background: rgba(255, 107, 107, 0.1);\n  border: 1px solid rgba(255, 107, 107, 0.3);\n  padding: 10px;\n  border-radius: 12px;\n}\n\n/* Dropzone */\n.dz {\n  border: 1px dashed var(--line);\n  background: var(--glass);\n  border-radius: 12px;\n  padding: 14px;\n  text-align: center;\n  min-height: 110px;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  transition: .2s;\n}\n\n.dz.over {\n  border-color: rgba(192, 255, 3, 0.55);\n  background: rgba(192, 255, 3, 0.08);\n}\n\n.dz-inner .dz-label {\n  display: block;\n  font-weight: 700;\n  color: white;\n}\n\n.dz-inner .dz-hint {\n  display: block;\n  color: var(--muted);\n  font-size: .9rem;\n  margin-top: 4px;\n}\n\n.dz-preview {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n.dz-preview img {\n  max-height: 70px;\n  max-width: 100%;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n.dz-filename {\n  font-size: .85rem;\n  color: var(--muted);\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ===== Barra di ricerca piloti ===== */\n.pilot-search {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: 14px;\n  box-shadow: var(--shadow);\n  margin: 12px 0 8px;\n  text-align: left;\n}\n\n.search-input {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.search-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 6px;\n}\n\n/* ===== Griglia piloti / card ===== */\n.pilots-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(250px, 1fr));\n  gap: 14px;\n  margin-bottom: 30px;\n}\n\n.pilots-grid-assegnazione {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0px, 1fr));\n  gap: 14px;\n  margin-bottom: 30px;\n}\n\n/* nuova card con più spazio alla colonna info */\n.pilot-card {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: 14px;\n  box-shadow: var(--shadow);\n  display: grid;\n  grid-template-columns: 140px 1fr auto;\n  /* più spazio alla colonna centrale */\n  gap: 14px;\n  align-items: center;\n}\n\n.pilot-card.expanded {\n  align-items: start;\n}\n\n.pilot-photos.col {\n  display: grid;\n  grid-template-rows: 1fr 90px;\n  gap: 10px;\n}\n\n.photo {\n  background: var(--glass);\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  height: 90px;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n}\n\n.photo.tall {\n  height: 180px;\n}\n\n.photo.small {\n  height: 90px;\n}\n\n.photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.photo-placeholder {\n  color: var(--muted);\n  font-size: .9rem;\n}\n\n.pilot-info {\n  text-align: left;\n}\n\n.pilot-info.wide {\n  padding-top: 4px;\n}\n\n.pilot-name {\n  font-weight: 900;\n  letter-spacing: .3px;\n  color: white;\n}\n\n.pilot-name.big {\n  font-size: 1rem;\n}\n\n.pilot-team {\n  color: var(--muted);\n  margin: 4px 0 10px;\n}\n\n.pilot-team.big {\n  font-size: 1.05rem;\n}\n\n.pilot-chips {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.pilot-actions {\n  display: flex;\n  align-items: center;\n}\n\n@media (max-width: 960px) {\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .pilots-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .pilot-card {\n    grid-template-columns: 110px 1fr;\n  }\n\n  .pilot-actions {\n    grid-column: 1 / -1;\n    justify-content: flex-end;\n  }\n}\n\n.cr-meta {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));\n  gap: 10px;\n  width: 100%;\n  margin-top: 6px;\n  /* opzionale, se ti serve spacing */\n}\n\n.cr-meta .pill {\n  display: block;\n  text-align: center;\n  border-radius: 999px;\n  padding: 6px 10px;\n  font-size: .9rem;\n  background: var(--glass);\n  border: 1px solid var(--line);\n  color: var(--fg);\n}\n\n/* ===== RaceSetup media helpers ===== */\n.media-box {\n  display: grid;\n  place-items: center;\n  background: var(--glass);\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n/* Foto pilota alta: copre tutto il box senza deformarsi */\n.pilot-photo-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Logo team nel box piccolo: centrato e contenuto */\n.team-logo-box {\n  background: var(--glass);\n}\n\n.team-logo-img {\n  max-height: 70px;\n  max-width: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));\n}\n\n/* Chip MAC più compatto */\n.mac-chip {\n  font-size: .8rem;\n  opacity: .9;\n}\n\n/* ---- from App.css lines 8373-8986 ---- */\n/* ===== PREMIUM PILOTS PAGE STYLES ===== */\n\n/* Header Premium */\n/* .pilots-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  padding: 24px;\n  background: linear-gradient(135deg, rgba(192, 255, 3, 0.08), rgba(192, 255, 3, 0.02));\n  border: 1px solid rgba(192, 255, 3, 0.2);\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n} */\n\n.pilots-header-content {\n  flex: 1;\n}\n\n.section-title-premium {\n  font-size: 2.2rem;\n  font-weight: 900;\n  margin: 0 0 8px 0;\n  color: var(--brand);\n  letter-spacing: -0.5px;\n  text-shadow: 0 0 30px rgba(192, 255, 3, 0.3);\n}\n\n.section-subtitle-text {\n  color: var(--muted);\n  font-size: 1rem;\n  margin: 0;\n}\n\n.pilots-stats {\n  display: flex;\n  gap: 20px;\n}\n\n.stat-card {\n  background: var(--glass);\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 16px 24px;\n  text-align: center;\n  min-width: 120px;\n  transition: all 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  border-color: rgba(192, 255, 3, 0.3);\n}\n\n.stat-value {\n  font-size: 2.5rem;\n  font-weight: 900;\n  color: var(--brand);\n  line-height: 1;\n  margin-bottom: 8px;\n}\n\n.stat-label {\n  font-size: 0.85rem;\n  color: var(--muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n/* Form Container Premium */\n.pilot-form-container {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  padding: 0;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  margin-bottom: 32px;\n  overflow: hidden;\n}\n\n.form-header {\n  background: linear-gradient(135deg, rgba(192, 255, 3, 0.12), rgba(192, 255, 3, 0.05));\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--line);\n}\n\n.form-title {\n  font-size: 1.4rem;\n  font-weight: 800;\n  margin: 0;\n  color: var(--fg);\n  letter-spacing: -0.3px;\n}\n\n.form-divider {\n  height: 3px;\n  background: linear-gradient(90deg, var(--brand), transparent);\n  margin-top: 12px;\n  border-radius: 2px;\n}\n\n.pilot-form-premium {\n  padding: 24px;\n}\n\n.form-section {\n  margin-bottom: 28px;\n}\n\n.section-label {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--brand);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 16px;\n  padding-bottom: 8px;\n  border-bottom: 2px solid rgba(192, 255, 3, 0.2);\n}\n\n.form-col-full {\n  grid-column: 1 / -1;\n}\n\n.input-premium {\n  width: 100%;\n  background: var(--glass);\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 12px 16px;\n  color: var(--fg);\n  font-size: 1rem;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.input-premium:focus {\n  border-color: rgba(192, 255, 3, 0.6);\n  box-shadow: 0 0 0 4px rgba(192, 255, 3, 0.1);\n  transform: translateY(-1px);\n}\n\n.input-premium::placeholder {\n  color: var(--muted);\n}\n\n.chips-premium {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.chip-premium {\n  border: 1px solid var(--line);\n  background: var(--glass);\n  padding: 10px 18px;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--fg);\n  position: relative;\n  overflow: hidden;\n}\n\n.chip-premium::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, rgba(192, 255, 3, 0.15), rgba(192, 255, 3, 0.05));\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.chip-premium:hover::before {\n  opacity: 1;\n}\n\n.chip-premium:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.chip-premium.active {\n  background: linear-gradient(135deg, rgba(192, 255, 3, 0.2), rgba(192, 255, 3, 0.1));\n  border-color: var(--brand);\n  color: var(--brand);\n  box-shadow: 0 0 20px rgba(192, 255, 3, 0.3);\n}\n\n.btn-primary-premium {\n  background: linear-gradient(135deg, var(--brand), #a8ff00);\n  color: #0a0a0a;\n  border: none;\n  padding: 14px 32px;\n  border-radius: 12px;\n  font-weight: 800;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 16px rgba(192, 255, 3, 0.3);\n}\n\n.btn-primary-premium:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(192, 255, 3, 0.4);\n}\n\n.btn-primary-premium:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn-primary-premium:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.btn-icon {\n  font-size: 1.2rem;\n  line-height: 1;\n}\n\n.btn-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #0a0a0a;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Search Premium */\n.pilot-search-premium {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  margin-bottom: 32px;\n}\n\n.search-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.search-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.btn-clear {\n  background: transparent;\n  border: 1px solid var(--line);\n  color: var(--fg);\n  padding: 8px 16px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.btn-clear:hover {\n  background: rgba(255, 107, 107, 0.1);\n  border-color: rgba(255, 107, 107, 0.5);\n  color: var(--down);\n}\n\n.search-bar {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.search-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--muted);\n  pointer-events: none;\n}\n\n.input-search-premium {\n  width: 100%;\n  background: var(--glass);\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 14px 16px 14px 48px;\n  color: var(--fg);\n  font-size: 1rem;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.input-search-premium:focus {\n  border-color: rgba(192, 255, 3, 0.6);\n  box-shadow: 0 0 0 4px rgba(192, 255, 3, 0.1);\n}\n\n.input-search-premium::placeholder {\n  color: var(--muted);\n}\n\n.filter-chips {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.filter-label {\n  font-size: 0.9rem;\n  color: var(--muted);\n  font-weight: 600;\n}\n\n.chip-premium-filter {\n  border: 1px solid var(--line);\n  background: var(--glass);\n  padding: 8px 16px;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--fg);\n}\n\n.chip-premium-filter:hover {\n  transform: translateY(-1px);\n  border-color: rgba(192, 255, 3, 0.4);\n}\n\n.chip-premium-filter.active {\n  background: linear-gradient(135deg, rgba(192, 255, 3, 0.2), rgba(192, 255, 3, 0.1));\n  border-color: var(--brand);\n  color: var(--brand);\n}\n\n/* Loading State */\n.loading-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  gap: 20px;\n}\n\n.spinner-large {\n  width: 48px;\n  height: 48px;\n  border: 4px solid var(--line);\n  border-top-color: var(--brand);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Error Premium */\n.error-premium {\n  color: var(--down);\n  background: rgba(255, 107, 107, 0.12);\n  border: 1px solid rgba(255, 107, 107, 0.4);\n  padding: 16px 20px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  font-weight: 600;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 80px 20px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));\n  border: 1px dashed var(--line);\n  border-radius: 16px;\n  margin: 20px 0;\n}\n\n.empty-icon {\n  font-size: 4rem;\n  margin-bottom: 16px;\n  opacity: 0.5;\n}\n\n.empty-state h3 {\n  font-size: 1.4rem;\n  font-weight: 800;\n  margin: 0 0 12px 0;\n  color: var(--fg);\n}\n\n/* Pilots Grid Premium */\n.pilots-grid-premium {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 24px;\n  margin-bottom: 40px;\n}\n\n/* Pilot Card Premium */\n.pilot-card-premium {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  overflow: hidden;\n  transition: all 0.4s ease;\n  position: relative;\n}\n\n.pilot-card-premium::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, rgba(192, 255, 3, 0.08), transparent);\n  opacity: 0;\n  transition: opacity 0.4s ease;\n  pointer-events: none;\n}\n\n.pilot-card-premium:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);\n  border-color: rgba(192, 255, 3, 0.4);\n}\n\n.pilot-card-premium:hover::before {\n  opacity: 1;\n}\n\n.pilot-card-header {\n  position: relative;\n  height: 220px;\n  background: linear-gradient(135deg, rgba(192, 255, 3, 0.1), rgba(192, 255, 3, 0.02));\n  overflow: hidden;\n}\n\n.pilot-avatar {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--glass);\n}\n\n.pilot-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.4s ease;\n}\n\n.pilot-card-premium:hover .pilot-avatar img {\n  transform: scale(1.05);\n}\n\n.pilot-team-logo {\n  position: absolute;\n  bottom: 12px;\n  right: 12px;\n  width: 56px;\n  height: 56px;\n  background: rgba(10, 10, 10, 0.9);\n  border: 2px solid var(--line);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n}\n\n.pilot-team-logo img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.pilot-card-body {\n  padding: 20px;\n}\n\n.pilot-name-premium {\n  font-size: 1.3rem;\n  font-weight: 900;\n  margin: 0 0 8px 0;\n  color: var(--fg);\n  letter-spacing: -0.3px;\n  line-height: 1.2;\n}\n\n.pilot-team-premium {\n  color: var(--muted);\n  font-size: 1rem;\n  margin: 0 0 16px 0;\n  font-weight: 600;\n}\n\n.pilot-badges {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.badge-championship,\n.badge-formula {\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.badge-championship {\n  background: linear-gradient(135deg, rgba(192, 255, 3, 0.2), rgba(192, 255, 3, 0.1));\n  color: var(--brand);\n  border: 1px solid rgba(192, 255, 3, 0.3);\n}\n\n.badge-formula {\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--fg);\n  border: 1px solid var(--line);\n}\n\n.pilot-card-footer {\n  padding: 16px 20px;\n  border-top: 1px solid var(--line);\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.btn-delete-premium {\n  width: 100%;\n  background: transparent;\n  color: var(--down);\n  border: 1px solid rgba(255, 107, 107, 0.4);\n  padding: 10px 16px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.btn-delete-premium:hover {\n  background: rgba(255, 107, 107, 0.12);\n  border-color: rgba(255, 107, 107, 0.6);\n  transform: translateY(-1px);\n}\n\n.btn-delete-premium svg {\n  transition: transform 0.3s ease;\n}\n\n.btn-delete-premium:hover svg {\n  transform: scale(1.1);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .pilots-header {\n    flex-direction: column;\n    gap: 20px;\n    text-align: center;\n  }\n\n  .pilots-stats {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .section-title-premium {\n    font-size: 1.8rem;\n  }\n\n  .pilots-grid-premium {\n    grid-template-columns: 1fr;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
